import { Scope } from '@fullstory/proto/fs/api/search';
import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';

export enum SegmentTypes {
  SetLastKnownSegment = 'Segments.SetLastKnownSegment',
}

export enum SegmentRequestTypes {
  GetSegmentRequest = 'SegmentProto.GetSegment.Request',
  GetSegmentSuccess = 'SegmentProto.GetSegment.Success',
  GetSegmentFailure = 'SegmentProto.GetSegment.Failure',
  GetAllSegmentsRequest = 'SegmentProto.GetAllSegments.Request',
  GetAllSegmentsSuccess = 'SegmentProto.GetAllSegments.Success',
  GetAllSegmentsFailure = 'SegmentProto.GetAllSegments.Failure',
  GetInitialSegmentsRequest = 'SegmentProto.GetInitialSegments.Request',
  GetInitialSegmentsSuccess = 'SegmentProto.GetInitialSegments.Success',
  GetInitialSegmentsFailure = 'SegmentProto.GetInitialSegments.Failure',
  SetSegmentRequest = 'SegmentProto.SetSegment.Request',
  SetSegmentSuccess = 'SegmentProto.SetSegment.Success',
  SetSegmentFailure = 'SegmentProto.SetSegment.Failure',
  ArchiveSegmentRequest = 'SegmentProto.ArchiveSegment.Request',
  ArchiveSegmentSuccess = 'SegmentProto.ArchiveSegment.Success',
  ArchiveSegmentFailure = 'SegmentProto.ArchiveSegment.Failure',
  StarSegmentRequest = 'SegmentProto.StarSegment.Request',
  StarSegmentSuccess = 'SegmentProto.StarSegment.Success',
  StarSegmentFailure = 'SegmentProto.StarSegment.Failure',
  FollowSegmentRequest = 'SegmentProto.FollowSegment.Request',
  FollowSegmentSuccess = 'SegmentProto.FollowSegment.Success',
  FollowSegmentFailure = 'SegmentProto.FollowSegment.Failure',
  MarkSegmentViewedRequest = 'SegmentProto.MarkSegmentViewed.Request',
  MarkSegmentViewedSuccess = 'SegmentProto.MarkSegmentViewed.Success',
  MarkSegmentViewedFailure = 'SegmentProto.MarkSegmentViewed.Failure',
  SegmentAccessRequest = 'SegmentProto.Access.Request',
  SegmentAccessSuccess = 'SegmentProto.Access.Success',
  SegmentAccessFailure = 'SegmentProto.Access.Failure',
}

export interface InitialSegmentIds {
  starred: string[];
  recent: string[];
}

export interface SegmentDetailWithScope extends SegmentDetail {
  segmentScope: Scope;
}
